import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { FiSettings } from "react-icons/fi";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import {
  Landing,
  CardLanding,
  PettyCashLanding,
  Aboutus,
  UpiCard,
  Contact,
  BusinessLanding,
  StaffAugmentation,
  ApiDocsPage,
  HubLiveLanding,
  PaymentSolutionsLanding,
  // PayInLandingPage,
  PayoutProcessLanding,
  IssuerDashboard,
  AcquirerServicesPage,
  Cybersecurity,
  Cloud,
  PayXLanding,
  Health,
  Recon,
  Merchant,
  Base24ServicesPage,
  DataAnalytics,
  CombinedAppServices,
  EngagementModel,
  TermsUse,
  PrivacyNotices,
  Careers,
  ECMSoftwarePage,
  AdminPortal,
  UpiSwitch,
  Blog,
  PostBlog,
  PaymentSolutions
} from "./pages";
// import { useStateContext } from "./contexts/ContextProvider";

import "./App.css";
import Switch from "./pages/switch";
import NETC from "./pages/netc";
import ClientsPage from "./pages/clients";


const App = () => {
  // const { activeMenu, themeSettings, setThemeSettings, currentColor, currentMode } = useStateContext();

  return (
    <div>
      <BrowserRouter>
        <div className="">
          <div>
            <Routes>
              <Route path="/business-landing" element={<BusinessLanding />} />
              <Route path="/landing" element={<Landing />} />
              <Route path="/card-landing" element={<CardLanding />} />
              <Route
                path="/petty-cash-landing"
                element={<PettyCashLanding />}
              />
              <Route path="/Aboutus" element={<Aboutus />} />
              <Route path="/Admin" element={<AdminPortal />} />
              <Route path="/Contact" element={<Contact />} />
              <Route path="/upiCard" element={<UpiCard />} />
              <Route path="/postBlog" element={<PostBlog />} />
              <Route path="/paymentSolutions" element={<PaymentSolutions />} />
              <Route path="/Switch" element={<Switch />} />

              <Route path="/developer" element={<ApiDocsPage />} />
              <Route path="/" element={<BusinessLanding />} />
              <Route
                path="/staff-augmentation"
                element={<StaffAugmentation />}
              />
              <Route
                path="/PayoutProcessLanding"
                element={<PayoutProcessLanding />}
              />
              {/* <Route path="/PayInLandingPage" element={<PayInLandingPage />} /> */}
              <Route path="/HubLiveLanding" element={<HubLiveLanding />} />
              <Route
                path="/PaymentSolutionsLanding"
                element={<PaymentSolutionsLanding />}
              />
              <Route path="/cybersecurity" element={<Cybersecurity />} />
              <Route path="/cloud" element={<Cloud />} />
              <Route path="/dms" element={<ECMSoftwarePage />} />
              <Route path="/recon" element={<Recon />} />
              <Route path="/termsUse" element={<TermsUse />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/privacyPolicy" element={<PrivacyNotices />} />
              <Route path="/merchant" element={<Merchant />} />
              <Route path="/industry" element={<EngagementModel />} />
              <Route path="/base24" element={<Base24ServicesPage />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/app-services" element={<CombinedAppServices />} />
              <Route path="/data-analytics" element={<DataAnalytics />} />
              <Route path="/payXLanding" element={<PayXLanding />} />
              <Route path="/IssuerDashboard" element={<IssuerDashboard />} />
              <Route path="/AcquirerServicesPage" element={<AcquirerServicesPage />} />
              <Route path="/netc" element={<NETC />} />
              <Route path="/clients" element={<ClientsPage />} />
              

            </Routes>
          </div>
        </div>
      </BrowserRouter>
    </div>
  );
};

export default App;
